module.exports = __webpack_public_path__ + "img/up.2d56d3d8.svg";